<template>
	<Confirmation :title="title"
		:text-field-enabled="textFieldEnabled"
		:button-options="buttonOptions"
		:styles="styles"
		@agree="handleAgree" @cancel="$emit('cancel')">
		<v-card-text class="pa-4">
			<span class="confirmation-message text-body-2" v-html="message"/>
		</v-card-text>
	</Confirmation>
</template>

<script>
import Confirmation from "@/components/dialogs/Confirmation.vue";

export default {
	name: "GeneralConfirmation",
	components: {Confirmation},

	props: ["title", "message", "textFieldEnabled", "buttonOptions", "styles"],

	emits: ["agree", "cancel"],

	methods: {
		handleAgree(arg) {
			this.$emit("agree", arg);
		}
	}
}
</script>

<style scoped lang="scss">
.confirmation-message {
	white-space: pre-wrap;
	justify-content: center;
	display: flex;
	flex-direction: column;
}
</style>